query GetFleetCounts {
  months: StreamToolsGetFleetUsage {
    month
    accountCount
    streamCount
    rolledUpAt
  }
}
